// extracted by mini-css-extract-plugin
var _1 = "TextareasBorderless-moduletextareaSkeleton__Lc0BP";
var _2 = "TextareasBorderless-moduletextareaSkeletonBox__i7ziV";
export { _1 as "textareaSkeleton", _2 as "textareaSkeletonBox" }
